import {getFormattedDateTimeNow, getMinutosHastaAhora} from './DateUtils'
//import {sessionCaducidadMinutos} from '../ej2shop/Configuracion'

export const crearSession= (authData) => {
    console.log("CREAR SESSION");
    console.log(authData);
    if (authData) {
        localStorage.setItem('EJ2SHOP_usuarioCodigo', authData.usuarioCodigo);
        localStorage.setItem('EJ2SHOP_token', authData.token);
        localStorage.setItem('EJ2SHOP_paginas', authData.paginas);
        localStorage.setItem('EJ2SHOP_date', getFormattedDateTimeNow());
    }
}

export const getSession= (sessionCaducidadMinutos) => {
    let usuarioCodigo= localStorage.getItem('EJ2SHOP_usuarioCodigo');
    if (usuarioCodigo){
        let token= localStorage.getItem('EJ2SHOP_token');
        let date= localStorage.getItem('EJ2SHOP_date');
        //let paginas= localStorage.getItem('EJ2SHOHP_paginas');
        let difMinutos=  getMinutosHastaAhora(date);
        console.log(difMinutos);
        if (difMinutos > sessionCaducidadMinutos){
            cerrarSession();
            return null;
        }
        else{
            return {
                usuarioCodigo: usuarioCodigo,
                token: token,
                //paginas: paginas,
                };
        }
    }
    else {
        return null;
    }

}

export const cerrarSession= () => {
    localStorage.removeItem("EJ2SHOP_usuarioCodigo");
    localStorage.removeItem("EJ2SHOP_token");
    localStorage.removeItem("EJ2SHOP_date");
}

export const refreshSession= (sessionCaducidadMinutos) => {
    let usuarioCodigo= localStorage.getItem('EJ2SHOP_usuarioCodigo');
    if (usuarioCodigo){
        let date= localStorage.getItem('EJ2SHOP_date');
        let difMinutos=  getMinutosHastaAhora(date);
        if (difMinutos <= sessionCaducidadMinutos){
            localStorage.setItem('EJ2SHOP_date', getFormattedDateTimeNow());
        }
        else{
            cerrarSession();
        }
    }
}

/*
export const sessionCaducada= () {
    let usuarioCodigo= localStorage.getItem('EJ2SHOP_usuarioCodigo');
    if (usuarioCodigo){
        let date= localStorage.getItem('EJ2SHOP_date');
        let difMinutos=  getMinutosHastaAhora(date);
        if (difMinutos > sessionCaducidadMinutos){
            localStorage.setItem('EJ2SHOP_date', getFormattedDateTimeNow());
        }
        else{
            cerrarSession();
        }
    }
}
*/